import { FETCH_EXERCISE_DATA } from './ActionTypes';

export function fetchExerciseData(locale, categoryKey, exerciseKey) {
    return {
        type: FETCH_EXERCISE_DATA,
        payload: { locale, categoryKey, exerciseKey }
    };
}
